module.exports = __webpack_public_path__ + "img/sand.708c1f78.svg";